import { render, staticRenderFns } from "./FemaleHealth.vue?vue&type=template&id=b40a8bc2&scoped=true&"
import script from "./FemaleHealth.vue?vue&type=script&lang=js&"
export * from "./FemaleHealth.vue?vue&type=script&lang=js&"
import style0 from "./FemaleHealth.vue?vue&type=style&index=0&id=b40a8bc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40a8bc2",
  null
  
)

export default component.exports